import { Box } from '@chakra-ui/react';

import { tableHeadLists } from './const';
import { useApp } from '@pages/UploadMappingV2/context/AppContext';
import TableListProduct from '@pages/UploadMappingV2/components/Table/TableListProduct';
import { useBundleStore } from '@pages/UploadMappingV2/hooks/state/useAddProductBundle';
import ModalAddProductBundle from '@pages/UploadMappingV2/components/ModalAddProductBundle';
import ModalConfirmAddProduct from '@pages/UploadMappingV2/components/ModalConfirmAddProduct';
import useMutateUploadMapping from '@pages/UploadMappingV2/hooks/mutate/useMutateUploadMapping';
import { useFilterPBundle } from '@pages/UploadMappingV2/hooks/state/useFilter';
import { usePaginationPBundle } from '@pages/UploadMappingV2/hooks/state/useAllMappingPagination';

export default function ProductBundle({ data, isLoading }) {
    const tableData = data?.data?.page_data;
    const { editProductBundle } = useMutateUploadMapping();
    const { isOpenModalConfirmAddProductBundle, onCloseModalConfirmAddProductBundle } = useApp();

    const { setSort } = useFilterPBundle();
    const { directBundles, resetBundles } = useBundleStore();
    const { page, limit, setPage, setLimit } = usePaginationPBundle();

    const handleConfirmSave = () => {
        const payload = directBundles.map(({ id, created_at, ...rest }) => ({
            ...rest,
            items: rest.items.map(({ id, created_at, brand, ...itemRest }) => itemRest),
        }))[0];

        editProductBundle.mutate({ id: directBundles[0].id, payload: { bundle: payload } });
    };

    const handleCancelSave = () => {
        onCloseModalConfirmAddProductBundle();
        resetBundles();
    };

    const onChangeSort = (sort) => setSort(sort);
    const onChangeLimit = (limit) => setLimit(limit);
    const onPageChange = (page) => setPage(page.selected + 1);

    return (
        <Box>
            <TableListProduct
                isCanAddItem={false}
                tableHeadLists={tableHeadLists}
                tableData={tableData}
                data={data?.data}
                isLoading={isLoading}
                isPagination={tableData?.length > 0}
                onChangeSort={onChangeSort}
                onChangeLimit={onChangeLimit}
                onPageChange={onPageChange}
                limit={limit}
                page={page}
            />

            <ModalAddProductBundle />

            <ModalConfirmAddProduct
                isOpen={isOpenModalConfirmAddProductBundle}
                onClose={handleCancelSave}
                onSubmit={handleConfirmSave}
            />
        </Box>
    );
}
